import { FormatWithProvider } from "@1js/localization-components";
import * as React from "react";
import {
  PromptGridTeamsNoPromptsOwnerSuccessDescriptionInner,
  PromptGridTeamsNoPromptsOwnerSuccessDescriptionOuter,
} from "./PromptResultsAnnouncement.strings";

export type SharePromptTextProps = {
  className?: string;
};

export const SharePromptText: React.FC<SharePromptTextProps> = ({
  className,
}) => {
  return (
    <div className={className}>
      <FormatWithProvider
        text={PromptGridTeamsNoPromptsOwnerSuccessDescriptionOuter}
        placeholders={{
          action: (
            <b>{PromptGridTeamsNoPromptsOwnerSuccessDescriptionInner()}</b>
          ),
        }}
      />
    </div>
  );
};
